import { push } from 'connected-react-router';

export const scenarioActions = {
  applyScenario,
  removeScenario
};

function applyScenario(scenarioId) {
  return { type: 'SCENARIO_APPLY_REQUEST', scenarioId };
}

function removeScenario() {
  //userService.logout();
  return { type: 'SCENARIO_REMOVE_REQUEST' };
}



// WEBPACK FOOTER //
// ./src/_actions/scenario.actions.js